import API_GATEWAY from "@/services/config/main-axios";

const merchantService = {
  getMerchantNames(filters) {
    return API_GATEWAY.get("user-profile/admin/merchantsName", {
      params: filters
    });
  },

  getMerchantTypes(filters) {
    return API_GATEWAY.get("user-profile/admin/business-type", {
      params: filters
    });
  },

  addMerchantCategory(model) {
    return API_GATEWAY.post("user-profile/admin/business-type/add", model);
  },

  changeCategoryStatus(model) {
    return API_GATEWAY.post(
      "user-profile/admin/business-type/changeStatus",
      model
    );
  },

  getAllMerchant(filters) {
    return API_GATEWAY.get("user-profile/admin/getAllMerchant", {
      params: filters
    });
  },

  getGateway(merchantId) {
    return API_GATEWAY.get(`user-profile/admin/gateways/${merchantId}`);
  },

  getGatewayCurrencyDetails(gatewayId) {
    return API_GATEWAY.post(
      `user-profile/admin/gateway/supportCurrency/${gatewayId}`
    );
  },

  getGatewayDetails(gatewayId) {
    return API_GATEWAY.get(`user-profile/admin/gateway/${gatewayId}`);
  },

  commissionPercentage(commissionData) {
    return API_GATEWAY.post(
      "user-profile/admin/merchant/contract/add",
      commissionData
    );
  },

  setDefaultCommission(merchantId) {
    return API_GATEWAY.post(
      "user-profile/admin/merchant/contract/setDefault",
      merchantId
    );
  }
};

export default merchantService;
